module.exports = __webpack_public_path__ + "static/media/resume.24318803.pdf";